import { useDispatch } from 'react-redux';
import { find, pick, propEq } from 'ramda';
import { useEffect, useCallback } from 'react';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

import * as actions from '../store/actions';

export const useDetectCurrency = () => {
    const { defaultCurrency, locationJson, allowedCurrencies } = useAppSelector(pick(['defaultCurrency', 'locationJson', 'allowedCurrencies']));
    const { country, currencyCode } = useUserSelector(pick(['country', 'currencyCode']));
    const dispatch = useDispatch();
    const locationItems = locationJson?.items;
    const getCurrency = useCallback(() =>
        allowedCurrencies.includes(currencyCode) && currencyCode, [allowedCurrencies, currencyCode]);

    useEffect(() => {
        const storeCurrency = getCurrency();

        if (!defaultCurrency || !country || !locationItems || storeCurrency) {
            return;
        }

        const countryMappingObj = find(propEq('countryCode', country), locationItems || []);
        const currency = countryMappingObj?.currency || defaultCurrency;

        dispatch(actions.setCurrencyCode(currency));
    }, [defaultCurrency, locationItems, country, dispatch, getCurrency]);
};
